import React, { useMemo } from "react";
import { isMobile } from "react-device-detect";
import classNames from "classnames";

// 고유 id 를 만들기 위한 배열
const uniqueId = [];

const FormRadio = ({ children, label, name, value, id, ...props }) => {
    const newId = useMemo(() => {
        // id 가 있을 경우 전달 받은 id 로 노출
        if (id) {
            return id;
        }

        // 전달 받은 id 가 없을 경우 name 을 기준으로 새로운 id 생성
        if (uniqueId[name] === undefined) {
            uniqueId[name] = 0;
        }

        return `${name}_${uniqueId[name]++}_radio`;
    }, [id, name]);

    return (
        <div className={classNames("radio-box", {on : props.on})}>
            {!isMobile && (
                <>
                    <span>
                        <input {...props} type="radio" id={newId} name={name} value={value} />
                        <i />
                    </span>
                    <label htmlFor={newId}>{label}</label>
                </>
            )}
            {isMobile && (
                <>
                    <input {...props} type="radio" id={newId} name={name} value={value} />
                    <label htmlFor={newId} className="checked">
                        <span>{label}</span>
                    </label>
                </>
            )}
            {children}
        </div>
    );
};

export default FormRadio;
